import type { AssetTypeEntity } from "@/entities/asset-type";

import { getModelLink } from "@/modules/model";

export const getAssetTypeTemplateLink = (assetType: AssetTypeEntity) => {
  const templateId = assetType.entity_template_id;

  if (!templateId) return undefined;

  return getModelLink("technicalform", { id: templateId });
};
